import DOMPurify from "dompurify";

export const MURAL_ALLOWED_TAGS = ["p", "br", "strong", "em", "b", "i", "ul", "ol", "li", "a"];
const MURAL_ALLOWED_ATTRIBUTES = ["href", "title", "target", "rel"];

export const normalizeMuralLink = (value) => {
  try {
    const parsed = new URL(String(value || "").trim());
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return null;
    return parsed.toString();
  } catch {
    return null;
  }
};

export const sanitizeMuralHtml = (value) => {
  const sanitized = DOMPurify.sanitize(typeof value === "string" ? value : "", {
    ALLOWED_TAGS: MURAL_ALLOWED_TAGS,
    ALLOWED_ATTR: MURAL_ALLOWED_ATTRIBUTES,
    ALLOW_ARIA_ATTR: false,
    ALLOW_DATA_ATTR: false,
    ALLOWED_URI_REGEXP: /^https?:\/\//i,
    FORBID_ATTR: ["style"],
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "svg", "math", "form", "input", "button"],
    SANITIZE_NAMED_PROPS: true,
  });

  const template = document.createElement("template");
  template.innerHTML = sanitized;
  template.content.querySelectorAll("a").forEach((link) => {
    const safeHref = normalizeMuralLink(link.getAttribute("href"));
    if (!safeHref) {
      link.removeAttribute("href");
      link.removeAttribute("target");
      link.removeAttribute("rel");
      return;
    }

    link.setAttribute("href", safeHref);
    link.setAttribute("rel", "noopener noreferrer");
    if (link.getAttribute("target") !== "_blank") link.removeAttribute("target");
  });

  return template.innerHTML.trim();
};

export const sanitizeMuralNotice = (notice) => ({
  ...notice,
  messageHtml: sanitizeMuralHtml(notice?.messageHtml),
});
